<!-- Rounded frame draws the outer border; the grid is nudged -1px so each cell's right/bottom border
     tucks under the frame (clipped by overflow-hidden), giving single lines and clean rounded corners. -->
<div class="overflow-hidden rounded-lg border border-solid border-default">
  <div class="-mr-px -mb-px grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
    @for (month of months(); track month.index) {
      <div class="flex min-h-4xl flex-col border-0 border-r border-b border-solid border-default">
        <div
          class="w-full border-0 border-b border-solid border-default bg-surface p-sm text-base font-semibold text-default"
        >
          {{ month.name }}
        </div>
        <div class="flex flex-col gap-2xs p-xs">
          @for (block of month.blocks; track block.absence.id) {
            @let absence = block.absence;
            @let option = absence.absenteeOption;
            @let pending = absence.status === 'Pending';
            <button
              type="button"
              class="reset-button flex flex-col rounded-lg border-2 border-solid px-xs py-2xs text-left text-sm font-medium tabular-nums"
              [class.text-on-color-light]="!pending && option.color_is_dark"
              [class.text-on-color-dark]="pending || !option.color_is_dark"
              [style.border-color]="option.color"
              [style.background-color]="pending ? null : option.color"
              [sbTooltip]="tooltip"
              sbTooltipMaxWidth="30rem"
              [appAbsenceRequest]="{ absenceId: absence.id ?? '', originator: 'absence-overview' }"
            >
              <span class="truncate font-semibold">{{ option.option }}</span>
              <span>
                {{ block.dateLabel }}
                @if (absence.open_ended) {
                  - {{ 'unknown' | translate }}
                }
                @if (block.duration) {
                  <span class="text-sm font-normal">({{ block.duration }})</span>
                }
              </span>
            </button>
            <ng-template #tooltip>
              <absence-tooltip [absences]="[absence]" />
            </ng-template>
          }
        </div>
      </div>
    }
  </div>
</div>
